import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import About from "./components/About";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Courses from "./components/Courses";
import CourseInfo from "./components/CourseInfo";
import CourseMaterials from "./components/CourseMaterials";
import Research from "./components/Research";
import Footer from "./components/Footer";

const App = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <BrowserRouter >
        <Navbar />
        <main className="text-gray-800 body-font flex-grow">
          <Switch>
            <Route component={About} path="/" exact />
            <Route component={Courses} path="/courses" />
            <Route component={Projects} path="/projects" />
            <Route component={CourseInfo} path="/courseInfo" />
            <Route component={CourseMaterials} path="/courseMaterials" />
            <Route component={Research} path="/research" />
          </Switch>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js